var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full relative"},[_c('Panorama'),_c('Header',{staticClass:"fixed top-0 z-10"}),_c('Transition',{attrs:{"name":"fade"}},[_c('RouterView',{staticClass:"z-10"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }